import Vue from 'vue'
import JczhUI from 'jczh-ui'

Vue.use(JczhUI)
